import { FC } from 'react';
import { Box, BoxProps, Icon as RooIcon, IconProps as RooIconProps } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';

const IconBackground = styled(Box)`
  border-radius: ${themeGet('radii.rounded')};
  line-height: 1;
`;

const StrokeIcon = styled(RooIcon)`
  fill: none;
  stroke: currentcolor;
  stroke-width: 1.2;
`;
StrokeIcon.displayName = 'StrokeIcon';

type IconPropKeys = 'name' | 'size' | 'title' | 'color';

interface IconProps extends Pick<RooIconProps, IconPropKeys>, Omit<BoxProps, IconPropKeys> {
  strokeOnly?: boolean;
}

const Icon: FC<IconProps> = ({ name, size, title, color, strokeOnly, ...boxProps }) => (
  <IconBackground {...boxProps}>
    {strokeOnly ? (
      <StrokeIcon name={name} size={size} title={title} color={color} />
    ) : (
      <RooIcon name={name} size={size} title={title} color={color} />
    )}
  </IconBackground>
);

Icon.defaultProps = {
  display: 'inline-block',
  strokeOnly: false,
};

export default Icon;
